<template>
    <b-modal
        v-model="modalVisible"
        size="lg"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <template v-slot:modal-title>
            <div class="pb-2">Envío masivo a Odoo - {{ ordersCount }} pedidos</div>
        </template>
        
        <!-- Información del lote -->
        <b-row class="mb-3">
            <b-col cols="12">
                <div class="p-3 bg-light rounded">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <p class="mb-1"><strong>Cantidad de pedidos:</strong> {{ ordersCount }}</p>
                            <p class="mb-0"><strong>IDs:</strong> {{ orderIds.join(', ') }}</p>
                        </div>
                        <b-icon icon="box-seam" font-scale="2" class="text-primary"></b-icon>
                    </div>
                </div>
            </b-col>
        </b-row>

        <!-- Advertencia -->
        <b-alert show variant="info" class="mb-3">
            <b-icon icon="info-circle" class="mr-2"></b-icon>
            Los pedidos se procesarán uno por uno en segundo plano. Recibirás una notificación cuando termine el proceso.
        </b-alert>
        
        <b-row>
            <b-col cols="12">
                <p class="font-weight-medium">Seleccione a qué instancia enviar todos los pedidos:</p>
            </b-col>
            <b-col cols="12">
                <b-form-select
                    v-model="selectedOdooInstanceId"
                    :options="[
                        { value: null, label: 'Seleccione una instancia', disabled: true },
                        ...activeOdooInstancesOptions
                    ]"
                    value-field="id"
                    text-field="label"
                    class="mb-3"
                    :disabled="isSending"
                ></b-form-select>
            </b-col>
        </b-row>

        <!-- Progreso (solo visible durante envío) -->
        <b-row v-if="isSending" class="mb-3">
            <b-col cols="12">
                <div class="text-center">
                    <b-spinner class="mr-2"></b-spinner>
                    <span>Procesando pedidos...</span>
                </div>
            </b-col>
        </b-row>
        
        <template v-slot:modal-footer>
            <b-button 
                variant="secondary" 
                @click.prevent="closeModal"
                :disabled="isSending"
            >
                Cancelar
            </b-button>
            <b-button 
                variant="primary" 
                @click.prevent="sendBatchToOdoo"
                :disabled="!isValidChoice || isSending"
            >
                <b-spinner small v-if="isSending" class="mr-2"></b-spinner>
                {{ isSending ? 'Enviando...' : 'Enviar Lote a Odoo' }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "SendBatchToOdooModal",
    props: {
        modalVisible: {
            type: Boolean,
            required: true
        },
        orderIds: {
            type: Array,
            default: () => []
        },
        ordersCount: {
            type: Number,
            required: true
        },
        odooInstances: {
            type: Array,
            default: () => []
        },
        isSending: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedOdooInstanceId: null
        }
    },
    computed: {
        activeOdooInstancesOptions() {
            return this.odooInstances
                .filter(instance => instance.status === true)
                .map(instance => ({
                    id: instance.id,
                    label: `${instance.name} - ${instance.mode === 'production' ? 'Producción' : 'Pruebas'}`
                }));
        },
        isValidChoice() {
            return this.selectedOdooInstanceId !== null;
        }
    },
    methods: {
        sendBatchToOdoo() {
            if (!this.isValidChoice) {
                return;
            }
            
            this.$emit('send-batch-to-odoo', this.selectedOdooInstanceId);
        },
        closeModal() {
            // Reiniciar el estado al cerrar
            this.selectedOdooInstanceId = null;
            this.$emit('close-modal');
        }
    },
    watch: {
        // Reiniciar cuando se abre el modal
        modalVisible(newVal) {
            if (newVal) {
                this.selectedOdooInstanceId = null;
            }
        }
    }
};
</script>

<style scoped>
.bg-light {
    background-color: #f8f9fa !important;
}
</style>